import { ChevronLeft } from "@clockwise/icons";
import { Tooltip } from "@clockwise/web-commons/src/ui/tooltip";
import { InfoRounded } from "@material-ui/icons";
import React, { memo } from "react";

export const Header = memo(function Header({
  title,
  description,
  onGoBack,
}: {
  title: string;
  description?: string;
  onGoBack?: () => void;
}) {
  return (
    <button
      onClick={onGoBack}
      className="cw-text-muted cw-w-full cw-px-3 cw-py-2 cw-cursor-pointer cw-bg-neutral cw-flex cw-gap-2 cw-items-center cw-border-t-0 cw-border-x-0 cw-border-b cw-border-solid cw-border-muted cw-overflow-hidden cw-whitespace-nowrap cw-text-ellipsis"
    >
      <div className="cw-flex cw-items-center cw-justify-between cw-gap-[3px] cw-overflow-hidden cw-whitespace-nowrap cw-text-ellipsis cw-w-full">
        {Boolean(onGoBack) && <ChevronLeft className="cw-text-muted cw-w-[14px] cw-h-[14px]" />}

        <span className="cw-overflow-hidden cw-whitespace-nowrap cw-text-ellipsis">{title}</span>
        <Tooltip header={title} placement="top" body={description || ""} showArrow={false}>
          <InfoRounded className="cw-text-subtle cw-w-[14px] cw-h-[14px] cw-mt-1" />
        </Tooltip>
      </div>
    </button>
  );
});
